<template>
    <div class="wc-input-wrapper" v-bind:class="{ 'has-error': invalid, 'has-success': isDirty, 'i-am-sunny': disabled }">
        <label v-if="label">{{ label }}</label>
        <input class="form-control"
            :type="type"
            :value="value"
            :placeholder="placeholder"
            @input="update"
            @blur="touch"
            :disabled="disabled" v-bind:class="{ 'i-am-sunny': disabled }">
        <div class="help-block animated fadeInDown">
            <span v-if="invalid && (customErrorMsg || errorMsg)">
                {{customErrorMsg || errorMsg}}
            </span>
            <span v-else class='ghostly'>
                &nbsp;
            </span>
        </div>
    </div>
</template>

<script>
    import wcValidateMixin from '../../../mixins/wc-validated-mixin.js'

    export default {
        mixins: [ wcValidateMixin ],
        props: {
            type: { type: String, default: 'text' },
            label: { type: String, default: null },
            value: { type: String, default: '' },
            placeholder: { type: String, default: '' },
            value0: { type: String, default: '' },
            neverDirty: { type: Boolean, default: false },
            disabled: { type: Boolean, default: false },
            customErrorMsg: { type: String, default: null },
        },
        computed: {
            isDirty () {
                return this.neverDirty === false && this.value0 !== this.value;
            }
        },
        methods: {
            update (e) {
                this.touch(e);
                this.$emit('input', e.target.value);
            },
        }
    };
</script>



// WEBPACK FOOTER //
// wc-input.vue?52549fa9